export const COMPLETE = 'verification_complete_screen';
export const FAILED = 'verification_failed_screen';
export const REQUIRED = 'verification_required_screen';
export const UPDATE_EMAIL = 'update_email_screen';
